import { render } from "./AccessibilityPanel.vue?vue&type=template&id=f106e782&scoped=true"
import script from "./AccessibilityPanel.vue?vue&type=script&lang=js"
export * from "./AccessibilityPanel.vue?vue&type=script&lang=js"

import "./AccessibilityPanel.vue?vue&type=style&index=0&id=f106e782&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f106e782"]])

export default __exports__